import React from 'react'

export const WaitView = () => {
  return (
      <div className="loader">
          <h2>Please wait...</h2>
      </div>  
  )
}
